import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Tickets/TicketsSubNav';

export const TicketsLayout = () => LayoutWithSubNav({ navId });
